import { Component, Input, OnInit } from '@angular/core';
import { IndicatorData } from 'app/models/indicator.interface';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    standalone: false
})
export class CardComponent implements OnInit {
  @Input() title: string;
  @Input() icon: string;
  @Input() iconsize: string;
  @Input() iconcolor: string;
  @Input() largetitle: string;
  @Input() to: string;
  @Input() subtitle: string;
  @Input() totype = 'card';
  @Input() lucideIcon: string;
  titleIdentifier: string;
  private _indicators?: IndicatorData[];
  @Input() set indicators(value: IndicatorData[] | string | undefined) {
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        this._indicators = Array.isArray(parsed) ? parsed : undefined;
      } catch {
        this._indicators = undefined;
      }
    } else {
      this._indicators = value;
    }
  }
  get indicators(): IndicatorData[] | undefined {
    return this._indicators;
  }

  constructor() {}

  ngOnInit() {
    if (this.title) {
      const splittedTitle = this.title.toLowerCase().split(' ');
      this.titleIdentifier = splittedTitle.length > 0 ? splittedTitle.join('-') : null;
    }
  }
}
